import type { HTMLAttributes } from 'vue';
import { cn } from '../../../lib/utils.ts';

export const touchTextareaZoomFixClass = 'touch-textarea-zoom-fix';

const textareaBaseClass = 'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50';

export function buildTextareaClass(className?: HTMLAttributes['class']) {
  return cn(textareaBaseClass, touchTextareaZoomFixClass, className);
}
